import React from 'react';
import { User, Phone } from 'lucide-react';

const EmergencyContactSection = ({ formData, handleInputChange }) => {
  return (
    <div className="border-t border-gray-200 pt-6 space-y-6">
      <div>
        <h3 className="text-base font-semibold text-gray-900">Emergency Contact</h3>
        <p className="mt-1 text-sm text-gray-600">Contact information in case of emergency</p>
      </div>

      <div className="grid grid-cols-1 gap-6 sm:grid-cols-6">
        <div className="sm:col-span-3">
          <label htmlFor="emergency_contact" className="block text-sm font-medium text-gray-900">
            <User className="inline h-4 w-4 mr-1.5 -mt-0.5 text-cyan-600" aria-hidden="true" />
            Contact Name
          </label>
          <div className="mt-2">
            <input
              type="text"
              id="emergency_contact"
              value={formData.emergency_contact}
              onChange={(e) => handleInputChange('emergency_contact', e.target.value)}
              className="block w-full rounded-md px-3 py-1.5 text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-cyan-600 sm:text-sm"
            />
          </div>
        </div>

        <div className="sm:col-span-3">
          <label htmlFor="emergency_phone" className="block text-sm font-medium text-gray-900">
            <Phone className="inline h-4 w-4 mr-1.5 -mt-0.5 text-cyan-600" aria-hidden="true" />
            Contact Phone
          </label>
          <div className="mt-2">
            <input
              type="tel"
              id="emergency_phone"
              value={formData.emergency_phone}
              onChange={(e) => handleInputChange('emergency_phone', e.target.value)}
              className="block w-full rounded-md px-3 py-1.5 text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-cyan-600 sm:text-sm"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default EmergencyContactSection;